//@ts-expect-error no type definition for baselines
import { iterativePolynomialBaseline as baselineFct } from 'baselines';
/**
 * @param data
 */
export function iterativePolynomialBaseline(data) {
    data.y = baselineFct(data.y).correctedSpectrum;
    return { data };
}
//# sourceMappingURL=iterativePolynomialBaseline.js.map